<div class="d-flex align-items-center">
  <div [ngClass]="collapsed ? 'mr-0' : 'mr-3'">
    @if (userLogo && !logoError) {
    <img
      class="client-logo"
        width="40"
        height="40"
        [src]="userLogo"
        (error)="onLogoError()"
      alt="user logo"
    />
    }
  </div>

  <div
    class="h-100"
    [ngClass]="collapsed ? 'mr-0' : 'mr-3'"
  >
    <div
      ngbDropdown
      class="d-flex"
      placement="bottom"
      (openChange)="toggleDropdownOpen($event)"
    >
      <div
        class="d-inline-flex align-items-center font-weight-bold text-primary font-size-normal medium cursor-pointer shadow-none"
        ngbDropdownToggle
      >
        @if (!collapsed) {
          <span class="label-container font-weight-bold text-primary font-size-normal user-box">
            {{ firstName }} {{ lastName }}
          </span>
        }
        <i
          class="far mx-1 font-size-small"
          [ngClass]="{ 'fa-chevron-up': dropdownOpen, 'fa-chevron-down': !dropdownOpen }"
        ></i>
      </div>

        <div
          ngbDropdownMenu
          class="dropdown-menu-dynamic custom-dropdown-position"
          [ngClass]="{
            'custom-dropdown-position-small': collapsed,
            'dropdown-wide': headerResponsivenessOptions.hideTimezoneSwitch && timezoneService.isVisible
          }"
        >
        @if (isDevMode && headerResponsivenessOptions.hideColorCodeLegend) {
          <div class="list-item">
            <div
              class="font-weight-bold text-primary"
              style="margin-top: -3px"
            >
              <app-language-switch
                [headerResponsivenessOptions]="headerResponsivenessOptions"
                class="font-weight-bold text-primary"
              />
            </div>
          </div>
        }

        @if (headerResponsivenessOptions.hideTimezoneSwitch && timezoneService.isVisible) {
          <div class="list-item list-item--tz">
            <div
              class="font-weight-bold text-primary"
              style="margin-top: -3px"
            >
              <app-timezone-switch [headerResponsivenessOptions]="headerResponsivenessOptions"></app-timezone-switch>
            </div>
          </div>
        }

        @for (option of options; track option.label) {
          <div class="list-item">
            <button
              ngbDropdownItem
              data-testid="user-box-option-button"
              class="font-weight-bold text-left font-size-small pl-3 m-0"
              (click)="optionSelected(option)"
            >
              <i
                class="far mr-2 icon-panel"
                [ngClass]="option.icon"
              ></i>
              {{ option.label | translate }}
            </button>
          </div>
        }
      </div>
    </div>

    @if (!collapsed) {
      <div class="font-size-small text-primary">{{ userPosition }}</div>
    }
  </div>
</div>
